import React from 'react'

import Section from '../layouts/Section.jsx'

import competitiveAnalysis from '_static/img/audience-insights/slides/section_bg-competitive_analysis.png'
import seasonality from '_static/img/audience-insights/slides/section_bg-seasonality.png'
import clientRecommendation from '_static/img/audience-insights/slides/section_bg-client_recommendation.png'
import marketingSlides from '_static/img/audience-insights/slides/section_bg-marketing_slides.png'

const images = [competitiveAnalysis, seasonality, clientRecommendation, marketingSlides]
const imagesByName = {
  'Competitive Analysis': competitiveAnalysis,
  Seasonality: seasonality,
  'Client Recommendation': clientRecommendation,
  'Marketing Slides': marketingSlides,
}

const Transition = (props) => {
  const imageIndex = props.index % images.length
  return (
    <Section
      title={props.data.title}
      showLogo={true}
      backgroundImage={imagesByName[props.data.title] ?? images[imageIndex]}
    />
  )
}

export default Transition
